//client-portal/src/components/auth/Signup.js
import React, { useState, useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { Link, useNavigate } from 'react-router-dom';
import { EyeIcon, EyeSlashIcon, ArrowLeftIcon, CheckCircleIcon, XCircleIcon } from '@heroicons/react/24/outline';
import { CheckCircleIcon as CheckCircleSolid, XCircleIcon as XCircleSolid } from '@heroicons/react/24/solid';
import { useAuth } from '../../context/AuthContext';

import { useSearchParams } from 'react-router-dom';  // ⭐ ADD THIS


import toast from 'react-hot-toast';

// Password Requirements Component
const PasswordRequirements = ({ password, isVisible }) => {
  if (!isVisible) return null;

  const requirements = [
    {
      label: 'At least one uppercase letter (A-Z)',
      test: /[A-Z]/,
      met: /[A-Z]/.test(password)
    },
    {
      label: 'At least one lowercase letter (a-z)',
      test: /[a-z]/,
      met: /[a-z]/.test(password)
    },
    {
      label: 'At least one number (0-9)',
      test: /[0-9]/,
      met: /[0-9]/.test(password)
    },
    {
      label: 'At least one special character (!@#$%^&*)',
      test: /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~`]/,
      met: /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~`]/.test(password)
    },
    {
      label: 'Minimum 6 characters',
      test: /.{6,}/,
      met: password?.length >= 6
    }
  ];

  return (
    <div className="mt-3 p-3 bg-gray-50 rounded-lg border border-gray-200">
      <p className="text-xs font-semibold text-gray-700 mb-2">Password must contain:</p>
      <div className="space-y-1.5">
        {requirements.map((req, index) => (
          <div
            key={index}
            className={`flex items-center text-xs transition-all duration-200 ${
              req.met ? 'text-green-600' : 'text-red-500'
            }`}
          >
            {req.met ? (
              <CheckCircleSolid className="w-4 h-4 mr-2 flex-shrink-0" />
            ) : (
              <XCircleSolid className="w-4 h-4 mr-2 flex-shrink-0" />
            )}
            <span className={req.met ? 'font-medium' : ''}>{req.label}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

const Signup = () => {
  const [currentStep, setCurrentStep] = useState(1);
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({});
  const [passwordFocused, setPasswordFocused] = useState(false);
  const [confirmPasswordFocused, setConfirmPasswordFocused] = useState(false);
  
    // ⭐ ADD THESE TWO LINES:
  const [searchParams] = useSearchParams();
  const adminRef = searchParams.get('ref');
  const caseRef = searchParams.get('case'); // ⭐ NEW
  const districtRef = searchParams.get('district');
  const courtCity   = searchParams.get('city');
  const courtState  = searchParams.get('state');   // ⭐ NEW



  const { signup } = useAuth();
  const navigate = useNavigate();
  
  const { register, handleSubmit, formState: { errors }, reset, watch } = useForm();
  const password = watch('password');
  const confirmPassword = watch('confirmPassword');

  // Scroll to top whenever component is loaded
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, []);

useEffect(() => {
  if (adminRef) {
    console.log('Signing up via admin referral:', adminRef);
    if (caseRef) {
      console.log('With case assignment:', caseRef);
     // toast.success('Welcome! Registering for your assigned case.');
    } else {
      //toast.success('Welcome! You\'re signing up through an admin referral.');
    }
  }
}, [adminRef, caseRef]); // ⭐ ADD caseRef dependency


  // Automatically scroll to top when loading starts
  useEffect(() => {
    if (loading) {
      window.scrollTo({ top: -60, behavior: 'smooth' });
    }
  }, [loading]);

  const nextStep = (data) => {
    setFormData({ ...formData, ...data });
    setCurrentStep(currentStep + 1);
  };

  const prevStep = () => {
    setCurrentStep(currentStep - 1);
  };

  const onSubmit = async (data) => {
    const finalData = {
      ...formData,
      ...data,
      name: `${formData.firstName || data.firstName} ${formData.lastName || data.lastName}`.trim(),
      referredByAdmin: adminRef || null,
       assignedCase: caseRef || null, // ⭐ NEW
      // district:        districtRef || null,  // ⭐ NEW
         district:        districtRef || null,
        courtCity:       courtCity   || null,
        courtState:      courtState  || null,   // ⭐ NEW
    };
    
    setLoading(true);

    // 3-second loading simulation
    setTimeout(async () => {
      try {
        const result = await signup(finalData);
        
        console.log('✅ Signup result:', result);
        
        // Check if signup was successful
        if (result.success) {
          // Show success messages
          toast.success(result.message);
          
          // ⭐ FIX: Check referredByAdmin in result.data (not result.data.data)
          if (result.data?.referredByAdmin?.hasReferral) {
           // toast.success('Your account has been linked to your referring admin!');
          }
          
          // ⭐ NEW: Show case assignment confirmation
        if (result.data?.assignedCase?.hasCaseAssignment) {
          ///toast.success('Your case has been assigned successfully!');
        }
        
        // ⭐ NEW: Show PDF generation confirmation
        if (result.data?.pdfGenerated) {
         // toast.success('Your case document has been generated!');
        }
          reset();
          setTimeout(() => {
            navigate('/identity-verification');
          }, 2000);
        } else {
          // If success is false
          toast.error(result.message || 'Registration failed. Please try again.');
        }
        
      } catch (error) {
        console.error('❌ Signup failed:', error);
        
        // Handle errors from the API
        if (error.response?.data) {
          const errorData = error.response.data;
          
          // Display validation errors
          if (errorData.errors && Array.isArray(errorData.errors)) {
            errorData.errors.forEach((err) => {
              toast.error(err.msg || err.message || 'Validation error');
            });
          } 
          // Display general error message
          else if (errorData.message) {
            toast.error(errorData.message);
          } 
          else {
            toast.error('Registration failed. Please try again.');
          }
        } else if (error.request) {
          // Request made but no response
          toast.error('No response from server. Please check your connection.');
        } else {
          // Something else went wrong
          toast.error('Registration failed. Please try again.');
        }
      } finally {
        setLoading(false);
      }
    }, 3000);
  };

  const getStepTitle = () => {
    switch(currentStep) {
      case 1: return 'Create Profile';
      case 2: return 'Create Secure Login';
      case 3: return 'Secure Database Profile';
      default: return '';
    }
  };

  // Enhanced password validation
  const validatePassword = (value) => {
    if (!value) return 'Password is required';
    if (value.length < 6) return 'Password must be at least 6 characters';
    if (!/[A-Z]/.test(value)) return 'Password must contain at least one uppercase letter';
    if (!/[a-z]/.test(value)) return 'Password must contain at least one lowercase letter';
    if (!/[0-9]/.test(value)) return 'Password must contain at least one number';
    if (!/[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~`]/.test(value)) {
      return 'Password must contain at least one special character (!@#$%^&*)';
    }
    return true;
  };

  if (loading) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center px-4">
        <div className="bg-white rounded-lg shadow-sm p-8 w-full max-w-md text-center">
          <div className="mb-6">
            <div className="w-16 h-16 border-4 border-blue-200 border-t-blue-600 rounded-full animate-spin mx-auto mb-4"></div>
            <h3 className="text-lg font-medium text-gray-900 mb-2">Creating your profile...</h3>
            <p className="text-sm text-gray-600">Please wait while we set up your account</p>
          </div>
          <div className="flex justify-center">
            <div className="flex space-x-1">
              <div className="w-2 h-2 bg-blue-600 rounded-full animate-bounce"></div>
              <div className="w-2 h-2 bg-blue-600 rounded-full animate-bounce" style={{animationDelay: '0.1s'}}></div>
              <div className="w-2 h-2 bg-blue-600 rounded-full animate-bounce" style={{animationDelay: '0.2s'}}></div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-50 py-8 px-4">
      <div className="max-w-md mx-auto">
        {/* Header */}
        <div className="text-center mb-8">
          <Link to="/" className="inline-flex items-center text-blue-600 text-sm mb-4">
            <ArrowLeftIcon className="w-4 h-4 mr-1" />
            Home
          </Link><br></br>

          {/* ⭐ ADD THIS SECTION 
          {adminRef && (
            <div className="mb-4 inline-block px-4 py-2 bg-green-100 text-green-800 rounded-full text-sm">
              ✓ County Referral Signup
            </div>
          )}*/}
          <h1 className="text-2xl font-semibold text-gray-900 mb-4" style={{fontFamily: 'Source Serif Pro'}}>eJuror Registration</h1>
          
          {/* Progress Steps */}
          <div className="flex justify-center space-x-2 mb-6">
            {[1, 2, 3].map((step) => (
              <div
                key={step}
                className={`w-5 h-5 rounded-full flex items-center justify-center text-sm font-medium ${
                  step <= currentStep
                    ? 'bg-[#0057a3] text-white'
                    : 'bg-gray-200 text-gray-500'
                }`}
              >
                {step < currentStep ? (
                  <CheckCircleIcon className="w-5 h-5" />
                ) : (
                  step
                )}
              </div>
            ))}
          </div>
        </div>

        {/* Form Container */}
        <div className="bg-white rounded-lg shadow-sm p-6">
          <h2 className="text-2xl font-semibold text-gray-900 mb-6" style={{fontFamily: 'Source Serif Pro'}}>{getStepTitle()}</h2>

          {/* Step 1: Create Profile (Name Only) */}
          {currentStep === 1 && (
            <div className="space-y-4">
              <div>
                <label className="block text-sm font-bold text-[#0057a3] mb-2">First Name</label>
                <input
                  {...register('firstName', {
                    required: 'First name is required',
                    minLength: { value: 2, message: 'First name must be at least 2 characters' }
                  })}
                  type="text"
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                  placeholder="Enter your first name"
                />
                {errors.firstName && <p className="mt-1 text-sm text-red-600">{errors.firstName.message}</p>}
              </div>
              <div>
                <label className="block text-sm font-bold text-[#0057a3] mb-2">Last Name</label>
                <input
                  {...register('lastName', {
                    required: 'Last name is required',
                    minLength: { value: 2, message: 'Last name must be at least 2 characters' }
                  })}
                  type="text"
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                  placeholder="Enter your last name"
                />
                {errors.lastName && <p className="mt-1 text-sm text-red-600">{errors.lastName.message}</p>}
              </div>

              <button
                type="button"
                onClick={handleSubmit(nextStep)}
                className="w-full bg-[#0057a3] text-white py-3 px-4 rounded-lg font-medium hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 transition-colors"
              >
                Continue
              </button>
            </div>
          )}

          {/* Step 2: Credentials */}
          {currentStep === 2 && (
            <div className="space-y-4">
              <div>
                <label className="block text-sm font-bold text-[#0057a3] mb-2">Email</label>
                <input
                  {...register('email', {
                    required: 'Email is required',
                    pattern: {
                      value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                      message: 'Invalid email address'
                    }
                  })}
                  type="email"
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                  placeholder="Enter your email"
                />
                {errors.email && <p className="mt-1 text-sm text-red-600">{errors.email.message}</p>}
              </div>

              <div>
                <label className="block text-sm font-bold text-[#0057a3] mb-2">Password</label>
                <div className="relative">
                  <input
                    {...register('password', {
                      required: 'Password is required',
                      validate: validatePassword
                    })}
                    type={showPassword ? 'text' : 'password'}
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent pr-10"
                    placeholder="Enter your password"
                    onFocus={() => setPasswordFocused(true)}
                    onBlur={() => setPasswordFocused(false)}
                  />
                  <button
                    type="button"
                    onClick={() => setShowPassword(!showPassword)}
                    className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-500 hover:text-gray-700"
                  >
                    {showPassword ? (
                      <EyeSlashIcon className="w-5 h-5" />
                    ) : (
                      <EyeIcon className="w-5 h-5" />
                    )}
                  </button>
                </div>
                {errors.password && !passwordFocused && (
                  <p className="mt-1 text-sm text-red-600">{errors.password.message}</p>
                )}
                <PasswordRequirements password={password} isVisible={passwordFocused} />
              </div>

              <div>
                <label className="block text-sm font-bold text-[#0057a3] mb-2">Confirm Password</label>
                <div className="relative">
                  <input
                    {...register('confirmPassword', {
                      required: 'Please confirm your password',
                      validate: value => value === password || 'Passwords do not match'
                    })}
                    type={showConfirmPassword ? 'text' : 'password'}
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent pr-10"
                    placeholder="Confirm your password"
                    onFocus={() => setConfirmPasswordFocused(true)}
                    onBlur={() => setConfirmPasswordFocused(false)}
                  />
                  <button
                    type="button"
                    onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                    className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-500 hover:text-gray-700"
                  >
                    {showConfirmPassword ? (
                      <EyeSlashIcon className="w-5 h-5" />
                    ) : (
                      <EyeIcon className="w-5 h-5" />
                    )}
                  </button>
                </div>
                {errors.confirmPassword && !confirmPasswordFocused && (
                  <p className="mt-1 text-sm text-red-600">{errors.confirmPassword.message}</p>
                )}
                <PasswordRequirements password={confirmPassword} isVisible={confirmPasswordFocused} />
              </div>

              <div className="flex space-x-3 pt-4">
                <button
                  type="button"
                  onClick={prevStep}
                  className="flex-1 bg-gray-200 text-gray-700 py-3 px-4 rounded-lg font-medium hover:bg-gray-300 focus:outline-none focus:ring-2 focus:ring-gray-500 focus:ring-offset-2 transition-colors"
                >
                  Back
                </button>
                <button
                  type="button"
                  onClick={handleSubmit(nextStep)}
                  className="flex-1 bg-[#0057a3] text-white py-3 px-4 rounded-lg font-medium hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 transition-colors"
                >
                  Continue
                </button>
              </div>
            </div>
          )}

          {/* Step 3: Secure Database Profile */}
          {currentStep === 3 && (
            <div className="space-y-4">
              <p className="text-sm text-gray-600 mb-4">
               Fill required fields and Submit to update your secure profile.
              </p>

              <div>
                <label className="block text-sm font-bold text-[#0057a3] mb-2">Date of Birth</label>
                <input
                  {...register('dateOfBirth', { required: 'Date of birth is required' })}
                  type="date"
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                  placeholder="MM/DD/YYYY"
                />
                {errors.dateOfBirth && <p className="mt-1 text-sm text-red-600">{errors.dateOfBirth.message}</p>}
              </div>

              <div>
                <label className="block text-sm font-bold text-[#0057a3] mb-2">SSN or TIN</label>
                <input
                  {...register('ssn', { required: 'SSN or TIN is required' })}
                  type="text"
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                  placeholder="XXX-XX-XXXX"
                />
                {errors.ssn && <p className="mt-1 text-sm text-red-600">{errors.ssn.message}</p>}
              </div>

              <div>
                <label className="block text-sm font-bold text-[#0057a3] mb-2">Residential Address</label>
                <input
                  {...register('address', { required: 'Address is required' })}
                  type="text"
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                  placeholder="123 main st"
                />
                {errors.address && <p className="mt-1 text-sm text-red-600">{errors.address.message}</p>}
              </div>

              <div>
                <label className="block text-sm font-bold text-[#0057a3] mb-2">City</label>
                <input
                  {...register('city', { required: 'City is required' })}
                  type="text"
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                  placeholder="New York"
                />
                {errors.city && <p className="mt-1 text-sm text-red-600">{errors.city.message}</p>}
              </div>

              <div className="grid grid-cols-2 gap-3">
                <div>
                  <label className="block text-sm font-bold text-[#0057a3] mb-2">State</label>
                  
                  <select
                    {...register('state', { required: 'State is required' })}
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                  >
                    <option value="">Select State</option>
                    <option value="AL">Alabama</option>
                    <option value="AK">Alaska</option>
                    <option value="AZ">Arizona</option>
                    <option value="AR">Arkansas</option>
                    <option value="CA">California</option>
                    <option value="CO">Colorado</option>
                    <option value="CT">Connecticut</option>
                    <option value="DE">Delaware</option>
                    <option value="FL">Florida</option>
                    <option value="GA">Georgia</option>
                    <option value="HI">Hawaii</option>
                    <option value="ID">Idaho</option>
                    <option value="IL">Illinois</option>
                    <option value="IN">Indiana</option>
                    <option value="IA">Iowa</option>
                    <option value="KS">Kansas</option>
                    <option value="KY">Kentucky</option>
                    <option value="LA">Louisiana</option>
                    <option value="ME">Maine</option>
                    <option value="MD">Maryland</option>
                    <option value="MA">Massachusetts</option>
                    <option value="MI">Michigan</option>
                    <option value="MN">Minnesota</option>
                    <option value="MS">Mississippi</option>
                    <option value="MO">Missouri</option>
                    <option value="MT">Montana</option>
                    <option value="NE">Nebraska</option>
                    <option value="NV">Nevada</option>
                    <option value="NH">New Hampshire</option>
                    <option value="NJ">New Jersey</option>
                    <option value="NM">New Mexico</option>
                    <option value="NY">New York</option>
                    <option value="NC">North Carolina</option>
                    <option value="ND">North Dakota</option>
                    <option value="OH">Ohio</option>
                    <option value="OK">Oklahoma</option>
                    <option value="OR">Oregon</option>
                    <option value="PA">Pennsylvania</option>
                    <option value="RI">Rhode Island</option>
                    <option value="SC">South Carolina</option>
                    <option value="SD">South Dakota</option>
                    <option value="TN">Tennessee</option>
                    <option value="TX">Texas</option>
                    <option value="UT">Utah</option>
                    <option value="VT">Vermont</option>
                    <option value="VA">Virginia</option>
                    <option value="WA">Washington</option>
                    <option value="WV">West Virginia</option>
                    <option value="WI">Wisconsin</option>
                    <option value="WY">Wyoming</option>
                  </select>
                  {errors.state && <p className="mt-1 text-sm text-red-600">{errors.state.message}</p>}
                </div>
                <div>
                  <label className="block text-sm font-bold text-[#0057a3] mb-2">ZIP Code</label>
                  <input
                    {...register('zipCode', { required: 'ZIP code is required' })}
                    type="text"
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                    placeholder="10001"
                  />
                  {errors.zipCode && <p className="mt-1 text-sm text-red-600">{errors.zipCode.message}</p>}
                </div>
              </div>

              <div>
                <label className="block text-sm font-bold text-[#0057a3] mb-2">Phone Number</label>
                <input
                  {...register('phone', { required: 'Phone number is required' })}
                  type="tel"
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                  placeholder="(123) 456-7890"
                />
                {errors.phone && <p className="mt-1 text-sm text-red-600">{errors.phone.message}</p>}
              </div>

              <div>
                <label className="block text-sm font-bold text-[#0057a3] mb-2">Alternate Phone (Optional)</label>
                <input
                  {...register('alternatePhone')}
                  type="tel"
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                  placeholder="(123) 456-7890"
                />
              </div>

              <div className="flex space-x-3 pt-4">
                <button
                  type="button"
                  onClick={prevStep}
                  className="flex-1 bg-gray-200 text-gray-700 py-3 px-4 rounded-lg font-medium hover:bg-gray-300 focus:outline-none focus:ring-2 focus:ring-gray-500 focus:ring-offset-2 transition-colors"
                >
                  Back
                </button>
                <button
                  type="button"
                  onClick={handleSubmit(onSubmit)}
                  className="flex-1 bg-[#0057a3] text-white py-3 px-4 rounded-lg font-medium hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 transition-colors"
                >
                  Submit Secure Profile
                </button>
              </div>
            </div>
          )}
        </div>

        {/* Sign In Link */}
        <div className="text-center mt-6">
          <p className="text-sm text-gray-600">
            Already have an account?{' '}
            <Link to="/login" className="text-blue-600 font-medium hover:text-blue-500">
              Sign in
            </Link>
          </p>
        </div>
      </div>
    </div>
  );
};

export default Signup;